import React from 'react';
import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { PersonSearchRounded } from '@mui/icons-material';

type ActionResponse = { id?: string; name?: string; username?: string } | null;
type ActionArgs = { username?: string; netCode?: string };

export type AndieGetProfileByUsernameProps = ActionRenderAi<ActionResponse, ActionArgs>;

const AndieGetProfileByUsername = (props: AndieGetProfileByUsernameProps) => {
    const { t } = useTranslation();
    return (
        <AndieGenericToolRender<ActionResponse, ActionArgs>
            title={() => t('andie.tool.get-profile-by-username.title')}
            icon={<PersonSearchRounded fontSize="small" />}
            network={props.args?.netCode}
            loadingMessages={(args) => [
                t('andie.tool.get-profile-by-username.loading', { value: args?.username ?? '' }),
            ]}
            completeMessage={() => t('andie.tool.get-profile-by-username.complete')}
            {...props}
        />
    );
};

export default AndieGetProfileByUsername;
